<h3>
	{{ 'PREBID_CONFIGURATION' | translate }}
</h3>
<bb-prebid-fields *ngIf="adunit?.prebidParams && hasAvailableSystems" [prebidParams]="adunit?.prebidParams" [filterParams]="prebidService.publicationPrebidParams" (change)="prebidParamsChanged()"></bb-prebid-fields>
<div class="info message" *ngIf="hasAvailableSystems === false"><i class="fa fa-info"></i>{{ 'PREBID_NO_ENABLED_SYSTEMS' | translate }}</div>
